import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../../providers/index';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class VideosProvider {
  tokenTMSAPI :string = 'tokenTMSAPI';
  baseUrl: String = this.globalServiceProvider.appConfig.bss_api;

  constructor(public http: Http, public globalServiceProvider: GlobalServiceProvider) {
  }

  getVideoByCustCode(custCode) {
    let result = null;
    return this.http
      .get(this.baseUrl + '/v2/instructionvideos/' + custCode.toUpperCase(),)
      .toPromise()
      .then((response: any) => {
        result = response.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  getVideoById(id) {
    let result = null;
    return this.http
      .get(this.baseUrl + '/instructionvideos/' + id,)
      .toPromise()
      .then((response: any) => {
        result = response.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/providers/videos-service/videos-service.ts